import { ConfigurationResponse } from "@idw-types/data";

export enum VerificationConfigActionTypes {
    SET_VERIFICATION_CONFIGURATION = "SET_VERIFICATION_CONFIGURATION",
    SET_VERIFICATION_CONFIGURATION_LOADING = "SET_VERIFICATION_CONFIGURATION_LOADING",
    SET_VERIFICATION_CONFIGURATION_LOADING_FAILED = "SET_VERIFICATION_CONFIGURATION_LOADING_FAILED",
    SET_VERIFY_TOKEN = "SET_VERIFY_TOKEN"
}

type SetVerificationConfigurationAction = {
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION,
    payload: { config: ConfigurationResponse };
};

export const setVerificationConfiguration = (config: ConfigurationResponse): SetVerificationConfigurationAction => ({
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION,
    payload: { config }
});

type SetVerificationConfigurationLoadingAction = {
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING,
    payload: { loading: boolean };
};

export const setVerificationConfigurationLoading = (loading: boolean): SetVerificationConfigurationLoadingAction => ({
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING,
    payload: { loading }
});

type SetVerificationConfigurationLoadingFailedAction = {
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING_FAILED
};

export const setVerificationConfigurationLoadingFailed = (): SetVerificationConfigurationLoadingFailedAction => ({
    type: VerificationConfigActionTypes.SET_VERIFICATION_CONFIGURATION_LOADING_FAILED
});

type SetVerifyTokenAction = {
    type: VerificationConfigActionTypes.SET_VERIFY_TOKEN,
    payload: { token: string };
};

export const setVerifyToken = (token: string): SetVerifyTokenAction => ({
    type: VerificationConfigActionTypes.SET_VERIFY_TOKEN,
    payload: { token }
});

export type VerificationConfigurationActions =
    SetVerificationConfigurationAction |
    SetVerificationConfigurationLoadingAction |
    SetVerificationConfigurationLoadingFailedAction |
    SetVerifyTokenAction